import { Component } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import CenterBox from "../../components/CenterBox";
import RemoteTimer from "../../components/Timer/RemoteTimer";
import { answerSelected } from "../../connection/config";
import { getOrCreatePlayerId } from "../../connection/reconnect";
import { toLetter } from "../../utilities";

import "./Question.css";

class Question extends Component {

    /**
     * Check if player is eliminated (knockout mode).
     */
    isEliminated() {
        return this.props.knockoutEnabled && this.props.playerStatus === "out";
    }

    getAnswerClassName(index) {
        const { selectedAnswer, correctAnswer, answersOpen } = this.props;
        const classes = ["player-answer"];

        // Show selected state
        if (selectedAnswer === index) {
            classes.push("player-answer--selected");
        }

        // After answers are closed, show correct/wrong feedback
        if (correctAnswer !== null && correctAnswer !== undefined) {
            if (index === correctAnswer) {
                classes.push("player-answer--correct");
            } else if (selectedAnswer === index) {
                classes.push("player-answer--wrong");
            }
        }

        // Disable interaction when answers are closed OR player is eliminated
        if (!answersOpen || this.isEliminated()) {
            classes.push("player-answer--locked");
        }

        return classes.join(" ");
    }

    answer(answer, index) {
        return (
            <Col md={6} sm={12} key={index}>
                <div
                    className={this.getAnswerClassName(index)}
                    onClick={() => this.selectAnswer(index)}
                >
                    <div className="player-answer-letter">{toLetter(index)}</div>
                    {answer}
                </div>
            </Col>
        );
    }

    QuestionGrid = () => {
        const { question } = this.props;
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <div className="player-question">
                            {question.question}
                        </div>
                    </Col>
                    {question.answers.map((answer, index) => this.answer(answer, index))}
                </Row>
            </div>
        );
    };

    selectAnswer = number => {
        // Only allow selection if answers are still open AND player is not eliminated
        if (this.props.question && this.props.answersOpen && !this.isEliminated()) {
            this.props.selected(number);
            // Send answer with playerId for stable identity
            const playerId = getOrCreatePlayerId();
            this.props.socket.emit(
                answerSelected,
                this.props.game.roomCode,
                playerId,
                this.props.game.playerName,
                this.props.question.index,
                number
            );
            // Stay on question screen - don't switch to V_WAITING
        }
    };

    /**
     * Render elimination banner for knocked out players.
     */
    renderEliminationBanner() {
        if (!this.isEliminated()) return null;

        return (
            <Alert variant="warning" className="knockout-eliminated-banner">
                <strong>You're out!</strong>
                <span> You can still follow along, but you can't answer.</span>
            </Alert>
        );
    }

    render() {
        return (
            <CenterBox logo logoSize="compact" cancel="Exit" {...this.props}>
                <div className="message-box">
                    {this.renderEliminationBanner()}
                    {this.props.game.hostingRoom.timeLimit > 0 && (
                        <RemoteTimer seconds={this.props.timer} />
                    )}
                    <br />
                    <Container fluid>
                        {this.props.question ? this.QuestionGrid() : false}
                    </Container>
                </div>
            </CenterBox>
        );
    }
}

export default Question;
